/**** Open Cart Drawer Function ****/
function openCartDrawer() {
    $('.cart-drawer').addClass('active');
    $('body').addClass('overflow-hidden');
}

/**** Close Cart Drawer Function ****/
function closeCartDrawer() {
    $('.cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
}

$(document).on("click", ".cart-icon--bubble", function () {
    openCartDrawer();
});

$(document).on("click", ".drawer-close, .cart-drawer-overlay", function () {
    closeCartDrawer();
});

/**** Discount : Code for on click event listener discount on mini cart ****/
$(document).on("click", ".cart-discount-wrapper .discount-text", function () {
    $(this).hide().next(".cart-discount-input-inner").show();
});

/**** Coupon discount input ****/
$(document).on("change keyup paste", ".cart-discount-wrapper .discount-input", function () {
    $(this).closest(".cart-discount-input-wrapper").find(".discount-button").attr("href", "/checkout?discount=" + $(this).val());
    $(this).val($(this).val());
});

/**** Cart Drawer Recommendations Product Slider Function ****/
function cartRecommendationsProduct() {
  $(".original .cart-drawer-fc").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ],
  });
}
cartRecommendationsProduct(); 

/**** Single and Multiple Items Add To Cart Function ****/
function addToCartEvent(items, element, freeItem, sections) {
  let formData = {
    'items': items,
  };
  if (!sections) {
    formData.sections = getSectionsToRender().map((section) => section.section);
  }
     
  fetch('/cart/add.js?product_add_to_cart', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    // console.log("Add.js response:: ", responseJson);
    if(element) {
      var elementName = element.prop('tagName')
      var btn_text = element.attr('data-available-text') || "Add To Cart";
      if(elementName == 'BUTTON') {
        element.text(btn_text);
      } else {
        element.val(btn_text);
      }
    }

    if(responseJson.description) {
      if(!freeItem) {
        showNotification(window.notificationErrorTemplate(responseJson.description));
      }
      $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
      return;
    }

    if(enableBundleFeature || enableMysteryColorFeature) {
      getCartEvent(0);
    }
    updateCartDrawer(responseJson);
    // showNotification(window.notificationMessages.add_to_cart);
    if($('.sticky-bottom-cart-bar:not(.is-hidden)').length > 0) {
      freeItem = true;
    }
    if(!freeItem) {
      openCartDrawer();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    if(element) {
      var elementName = element.prop('tagName')
      var btn_text = element.attr('data-available-text') || "Add To Cart";
      if(elementName == 'BUTTON') {
          element.text(btn_text);
      } else {
          element.val(btn_text);
      }
    }
    $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
  });
}

/**** Update Single Item Quantity Function ****/
function updateQuantity(lineItemKey, quantity, input, sections) {
  let formData = {
    'id': lineItemKey,
    'quantity': quantity,
  };
  if (!sections) {
    formData.sections = getSectionsToRender().map((section) => section.section);
  }
     
  fetch('/cart/change.js?item_quantity_update', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    if(responseJson.description) {
      if(input) input.val(quantity - 1);
      showNotification(window.notificationErrorTemplate(responseJson.description));
      $('.cart-remove-button').removeClass('loading__spinner');
      $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
      return;
    }

    updateCartDrawer(responseJson);
    if(enableBundleFeature || enableMysteryColorFeature) {
      getCartEvent(responseJson);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    $('.cart-remove-button').removeClass('loading__spinner');
    $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
  });
}

/**** Update Multiple Items Quantity Function ****/
function updateMultipleItemsQty(items, sections) {
  if (!sections) {
    sections = getSectionsToRender().map((section) => section.section);
  }
  let itemsData = {
    'updates': items,
    'sections': sections
  };
  
  fetch('/cart/update.js?multiple_item_update', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
      body: JSON.stringify(itemsData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    if($('.c_drawer-bottom-btn').length > 0) {
      $('.c_drawer-bottom-btn').removeClass('btn-disable');
    }
    if(responseJson.description) {
      if(input) input.val(quantity - 1);
      showNotification(window.notificationErrorTemplate(responseJson.description));
      $('.cart-remove-button').removeClass('loading__spinner');
      $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
      return;
    }
    updateCartDrawer(responseJson);
    if(enableBundleFeature || enableMysteryColorFeature) {
      getCartEvent(responseJson);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    if($('.c_drawer-bottom-btn').length > 0) {
      $('.c_drawer-bottom-btn').removeClass('btn-disable');
    }
    $('.cart-remove-button').removeClass('loading__spinner');
    $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
  });
}

/**** Update Cart Drawer HTML Function ****/
function updateCartDrawer(response) {
  if (!response) return;
  var cart_drawer_html = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
  var sourceElement = cart_drawer_html.querySelector('#shopify-section-cart-drawer');
  var itemCount = sourceElement.querySelector('.cart-drawer-wrapper').getAttribute('data-item-count');
  
  var rangeWidth = sourceElement.querySelector('.shipping-bar-wrapper').getAttribute('data-range-width');
  $('.shipping-bar_progress-range').css("width", rangeWidth);
  $('.cart-count-bubble').text(itemCount);
  
  var getSections_Render = getSectionsToRender();
  $.each(getSections_Render, function(key, section) {
    const elementToReplace = $('#'+section.id).find(section.selector) || $('#'+section.id);
    if(elementToReplace.length > 0) {
      elementToReplace.html(getSectionInnerHTML(response.sections[section.section], section.selector))
    }
  });
  if ($("#colorPopup").length > 0) {
    $("#colorPopup").removeClass("active");
    $("body, html").removeClass("overflow-scroll");
  }

  initStickyCartBar();

  cartRecommendationsProduct();
  $('.cart-remove-button').removeClass('loading__spinner');
  $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
}

/**** Get HTML Functions ****/
function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

function getSectionsToRender() {
  return [
    {
      id: 'cart_drawer_wrapper',
      section: 'cart-drawer',
      selector: '.cart-drawer-form-wrapper',
    },
    {
      id: 'bundle-announcement-bar',
      section: 'bundle-announcement-bar',
      selector: '.announcement-bar-wrapper',
    },
    {
      id: 'sticky-cart-bar',
      section: 'sticky-cart-bar',
      selector: '.sticky-cart-bar__wrapper',
    }
  ];
}

/**** Get cart function ****/
function getCartEvent(cart) {
  if (cart === 0 || cart == '' || cart === undefined) {
    fetch('/cart.js?get_cart', {
      method: 'GET'
    })
    .then(response => {
      return response.json();
    })
    .then(responseJson => {
      // console.log("Get cart data event response:: ", responseJson);
      enableBundleFeature && slabHandle(responseJson);
      enableMysteryColorFeature && mystery_free_products(responseJson);
      updateFreeProductQuantity(responseJson);
      parentToChild(responseJson);
      childToParent(responseJson);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  } else {
    // console.log("Get cart data response:: ", cart);
    enableBundleFeature && slabHandle(cart);
    enableMysteryColorFeature && mystery_free_products(cart);
    updateFreeProductQuantity(cart);

    // parentToChild(cart);
    // childToParent(cart);
  } 
}

$(document).ready(function () {
  if(enableBundleFeature || enableMysteryColorFeature) {
    getCartEvent(0);
  }
});

/**** Update the Free Product Quantity function ****/
function updateFreeProductQuantity(cart) {
  var ind = 0;
  let updates = {};
  $.each(cart.items, function (ind, b) {
    if(enableBundleFeature){
      if (excluded_variant_ids.includes(b.variant_id) && b.quantity > 1) {
        updates[b.id] = 1;
      }
    }
    if(enableMysteryColorFeature) {
      if (free_variant_id.includes(b.variant_id) && b.quantity > 1) {
        updates[b.id] = 1;
      }
    }
  });
  
  if (Object.keys(updates).length > 0) {
    var getSections = getSectionsToRender().map((section) => section.section);
    $.ajax({
      type: "POST",
      url: "/cart/update.js?Free-Item-Update-QTY",
      data: JSON.stringify({ updates: updates, sections: getSections }),
      contentType: "application/json",
      dataType: "json",
      success: function(response) {
        console.log("Free item quantity updated successfully");
        if(response) {
          updateCartDrawer(response)
        }
      },
      error: function(error) {
        console.error("Error updating cart", error);
      }
    });
  }
}
  
/**** Clear cart function ****/
function clearCartEvent() {
  let data = {
    'sections': getSectionsToRender().map((section) => section.section)
  };
  
  fetch('/cart/clear.js?clear-cart-function', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    updateCartDrawer(responseJson);
    console.log("Cart cleared successfully");
  })
  .catch((error) => {
    console.error('Error:', error);3
    $('.cart-remove-button').removeClass('loading__spinner');
  });
}

function childToParent(cart) {
  let addonItems = cart.items.filter((item) => {
    let item_properties = item.properties;
    return item_properties && "_addon" in item_properties;
  });

  if (addonItems.length > 0) {
    addonItems.forEach((addonItem) => {
      let targetProduct = addonItem.properties["_main_product"];
      let targetProductId = targetProduct.split(":")[0];
      let targetTimeProperty = addonItem.properties["_time"];
      let isProductInCart = cart.items.some((item) => {
        let item_properties = item.properties;
        if (item_properties && "_time" in item_properties) {
          let mainProductID = item.product_id;
          let timeProperty = item_properties["_time"];
          return (mainProductID == targetProductId && timeProperty == targetTimeProperty);
        }
        return false;
      });

      if (!isProductInCart) {
        console.log("Cart cleared successfully");
        clearCartEvent();
      }
    });
  } else {
    console.log("No item with _addon found in the cart.");
  }
}

function parentToChild(result) {
  let mainItem = result.items.filter((item) => {
    let item_properties = item.properties;
    return item_properties && "_kittt" in item_properties;
  });

  let addonItem = result.items.filter((item) => {
    let item_properties = item.properties;
    return item_properties && "_addon" in item_properties;
  });

  if (mainItem.length > 0) {
    mainItem.forEach((parentItem) => {
      let addonitemqty = parseInt(parentItem.properties["_varinat_size"]);
      let targetTimeProperty = parentItem.properties["_time"];
      let itemProperty = parentItem.properties;

      const newArray = [];
      for (const key in itemProperty) {
        if (key.startsWith("_plus-")) {
          let varientId = parseInt(itemProperty[key]);
          newArray.push(varientId);
        }
      }
      if (newArray.length == addonitemqty) {
        let count = 0;
        addonItem.forEach((addon) => {
          let addonTime = addon.properties["_time"];
          if (addonTime == targetTimeProperty) {
            count++;
          }
        });
        if (count != addonitemqty) {
          console.log("clearCartEvent()")
          clearCartEvent();
        }
      } else {
        console.log("clearCartEvent()")
        clearCartEvent();
      }
    });
  }
}

/**** Add and remove notification message in body ****/
function showNotification(message) {
  if (window.notificationSuccessTemplate) {
    var template = $('<template></template>');
    message = window.notificationSuccessTemplate(message).trim();
    template.html(message);

    var notificationElement = template.contents().first();
    $(notificationElement).css('opacity', '0').css('zIndex', '99999999').appendTo('body');

    setTimeout(function () {
      $(notificationElement).css('opacity', '1');
    }, 200);

    setTimeout(function () {
      $(notificationElement).css('opacity', '0');
      setTimeout(function () {
        $(notificationElement).remove();
      }, 200);
    }, 3000);
  }
}

/**** Update the Cart drawer from add to cart button on click event ****/
$(document).on("click", ".btn_addToCart", function (e) {
  e.preventDefault();
  var loading_text = $(this).attr('data-loading-text') || 'Adding to cart...'
  $(this).val(loading_text);
  var form = $(this).parents('.add-to-cart-form');
  var variantID = parseInt(form.find('input[name="id"]').val());;
  var qty = parseInt(form.find('input[name="quantity"]').val());
  var items = [
    {
      'id': variantID,
      'quantity': qty
    }
  ]
  addToCartEvent(items, $(this));  
}); 

$(document).on("click", ".c_drawer-fc-button", function (e) {
  e.preventDefault();
  var loading_text = $(this).attr('data-loading-text') || 'Adding to cart...'
  $(this).addClass('added-cart').text(loading_text);
  var variantID = parseInt($(this).attr('data-id'));
  var qty = parseInt($(this).attr('data-qty'));
  var items = [
    {
      'id': variantID,
      'quantity': qty
    }
  ]
  addToCartEvent(items, $(this));  
  setTimeout(function () {
    $('.c_drawer-fc-button').removeClass('added-cart');
  }, 800);
});

$(document).on("click", ".spf-product__form-btn-addtocart:not(.password_protected)", function (e) {
  e.preventDefault();
  var loading_text = $(this).attr('data-loading-text') || 'Adding to cart...'
  $(this).text(loading_text);
  var variantID = parseInt($(this).attr('data-id'));
  var qty = parseInt($(this).attr('data-qty'));
  var items = [
    {
      'id': variantID,
      'quantity': qty
    }
  ]
  addToCartEvent(items, $(this));  
});   

/**** Single Product Form Data Add To Cart Function ****/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function formDataWithAddToCart(form) {
  if(!form) return;
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var btn_input = form.querySelector('.addtocart') || form.querySelector('.c_drawer-fc-button');
    btn_input.value = btn_input.getAttribute('data-loading-text') || 'Adding to cart...'
  
    const formData = new FormData(form);
    formData.append('sections', getSectionsToRender().map((section) => section.section));

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    config.body = formData;
    fetch('/cart/add.js?form_data_addToCart', config)
    .then(response => {
        return response.json();
    })
    .then(responseJson => {
      if(btn_input) {
        btn_input.value= "Add To Cart";
      }

      if(responseJson.description) {
        showNotification(window.notificationErrorTemplate(responseJson.description));
        $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
        return;
      }

      if(enableBundleFeature || enableMysteryColorFeature) {
        getCartEvent(0);
      }

      if($('.color-product .custom-slider-container').length > 0) {
        $('body, html').removeClass('overflow-scroll');
        $(".color-product .custom-slider-container").fadeOut("fast");
      }
      
      updateCartDrawer(responseJson);
      showNotification(window.notificationMessages.add_to_cart);
      if($('.sticky-bottom-cart-bar:not(.is-hidden)').length == 0) {
        openCartDrawer();
      }
    })
    .catch((error) => {
        console.error('Error:', error);
    }).finally(() => {
      if(btn_input) {
        btn_input.value= "Add To Cart";
      }
    });
  });
}
var forms = document.querySelectorAll('.add-to-cart-form');
forms.forEach(function (form) {
  formDataWithAddToCart(form);
});

/**** Kit Items Add To Cart Function ****/
function kitProductsAddToCart(form) {
  if(!form) return;
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var btn_input = form.querySelector('.addtocart');
    btn_input.value = btn_input.getAttribute('data-loading-text') || 'Adding to cart...'
    
    let count = 0;
    let checkboxCount = 0;
    var varianr_size = $('.kit-product-template .kit-package-options label.variation-element.selected .custom-option-header').data("tv");
    let items = [];
    $(".custom-add-checkbox:checked").each(function (index) {
      const obj = {
        id: $(this).attr("data-vid"),
        quantity: 1
      };
      items.push(obj);
      count++;
      checkboxCount++;
    });
    $(".colors-final-content:not(.color_final_custom_content) .color-line-item").each(function (index) {
      const obj = {
        id: $(this).attr("data-vid"),
        quantity: $('#quantity-8c0e255ffbb7a0262a0a13d5fcdb8508').val(),
        properties: {
          '_addon': true,
           '_item_index': $(this).attr("data-item-index"),
          '_vt': $(".custom-option-label.selected .custom-option-text").attr('data-option-vt'),
          '_time': $(".custom-option-label.selected .custom-option-text").attr("data-second"),
          '_main_product': `${meta.product.id}: V:${$(`.kit-add-to-cart-form select[name="id"]`).val()}`
        }
      };
      items.push(obj);
      count++;
    });

    const formData = new FormData(form);
    const productData = {};

    // Parse form data into an object
    for (const [key, value] of formData.entries()) {
      if (key.startsWith("properties[")) {
        const propertyKey = key.match(/properties\[(.+)\]/)[1];
        if (!productData.properties) {
          productData.properties = {};
        }
        productData.properties[propertyKey] = value;
      } else {
        productData[key] = value;
      }
    }

    // Add the parsed product data to the items array
    items.push(productData);
    var itemsArrLength = items.length - 1;
    
    if (count > 0 && itemsArrLength == varianr_size + checkboxCount) {
      addToCartEvent(items, $(this).find('.addtocart'));  
    } else {
      alert("selected variant missing");
      clearCartEvent();
    }
  });
}
var form = document.querySelector('.kit-add-to-cart-form');
kitProductsAddToCart(form);

/**** Mini Drawer on plus and minus click quantity update ****/
$(document).on("click", ".btn-qty-plus:not(.disabled), .btn-qty-minus:not(.disabled)", function (e) {
  e.preventDefault();
  var input = $(this).closest(".wrapperplus-a").find(".quantity__input");
  var oldVal = input.val();
  var newVal = 0;
  $(this).parents('.product-row').find('.cart-remove-button').addClass('loading__spinner');
  if ($(this).attr('data-name') == 'plus') {
      newVal = parseInt(oldVal) + 1;
  } else {
      newVal = parseInt(oldVal) - 1;
  }

  input.val(newVal);

  var kit_item = $(this).parents('.mini-cart-list-item');
  if(kit_item.hasClass('mini-cart-kit')) {
    var kitItems = kit_item.find('.kit-remove-button').attr('data-kit-items')
    let updates = {};
    kitItems.split(",").filter(Boolean).forEach((id, index) => {
        updates[id] = newVal;
    });
    updateMultipleItemsQty(updates);
  } else {
    var line_item_key = $(this).parents('.mini-cart-list-item').attr('data-item-key');
    var qty = parseInt(input.val());
    updateQuantity(line_item_key, qty, input);
  }
});

/**** Mini Drawer on remove button click item remove ****/
$(document).on("click", ".cart-remove-button:not(.kit-remove-button)", function (e) {
    e.preventDefault();
    $(this).addClass('loading__spinner');
    var line_item_key = $(this).parents('.mini-cart-list-item, .sticky-cart-bar__item').attr('data-item-key');
    updateQuantity(line_item_key, 0);
});

$(document).on("click", ".kit-remove-button", function (e) {
    e.preventDefault();
    $(this).addClass('loading__spinner');
    var kitItems = $(this).attr('data-kit-items');
    let updates = {};
    $('.c_drawer-bottom-btn').addClass('btn-disable');
    kitItems.split(",").filter(Boolean).forEach((id, index) => {
        updates[id] = 0;
    });

    updateMultipleItemsQty(updates);
});

/**** Code related with Cart-related functionalities ****/
$(document).on("click", ".cs_checkout_btn", function (event) {
  event.preventDefault();
  const button = $(this);
  button.html("Checking Out...");
  setTimeout(() => {
    button.html("Secure Checkout");
  }, 15000);

  jQuery.getJSON("/cart.js?cs_checkout_btn", function (cart) {
    let updates = {};
    $.each(cart.items, function (index, item) {
      if (item.product_title && !item.product_title.includes("Gift") && item.price === 0 && item.product_title.includes("#") && (!item.properties || Object.keys(item.properties).length === 0)) {
        if (item.key && item.quantity > 0) {
          updates[item.key] = 0;
        }
      }
    });
    
    if (cart.total_price < 1 && cart.total_discount < 1) {
      clearCartEvent();
      button.html("Secure Checkout");
    } else {
      let giftLogString = "";
      let hasSurpriseGift = false;
      let hasKitProduct = false;
    
      cart.items.forEach((item) => {
        let isSurpriseGift = item.properties && item.properties._free_gift === "true";
        let isKitProduct = item.product_type && item.product_type.toLowerCase().includes("kit");
    
        if (isSurpriseGift) {
          hasSurpriseGift = true;
          giftLogString += `${item.id}, `;
        }
        if (isKitProduct) {
          hasKitProduct = true;
        }
      });

      let missingItems = [];
      if (enableBundleFeature) {
        const cartVariantIds = cart.items.map(item => item.variant_id);
        missingItems = Array.isArray(surprise_gift_itemsToAdd) ? surprise_gift_itemsToAdd.filter(item => !cartVariantIds.includes(item.id)) : [];
        console.log('missingItems:: ', missingItems, surprise_gift_itemsToAdd);
      }
      
      giftLogString = giftLogString.trim().replace(/,\s*$/, "");
    
      let surprise_gift_logs = JSON.parse(localStorage.getItem('surprise_gift_logs')) || [];
      if (hasSurpriseGift && giftLogString.length > 0) {
        let fullLog = `Cart Surprise Gift IDs: ${giftLogString} | ${new Date().toLocaleString()}`;
        if (Array.isArray(surprise_gift_logs) && surprise_gift_logs.length > 0) {
          surprise_gift_logs.push(fullLog);
          localStorage.setItem('surprise_gift_logs', JSON.stringify(surprise_gift_logs));
        }
      }
      // console.log('Check the enableBundleFeature:: ', enableBundleFeature);
      if (enableBundleFeature && Array.isArray(missingItems) && missingItems.length > 0) {
        // console.log("Cart Kit without Surprise Gift >> hasKitProduct:", hasKitProduct, "hasSurpriseGift:", hasSurpriseGift);
        const missingItemIds = missingItems.map(item => item.id || item).join(', ');
        let kitOnlyLog = `Cart Kit without Surprise Gift | ${new Date().toLocaleString()} | Missing Items: [${missingItemIds}]`;
        if (Array.isArray(surprise_gift_logs) && surprise_gift_logs.length > 0) {
          surprise_gift_logs.push(kitOnlyLog);
          localStorage.setItem('surprise_gift_logs', JSON.stringify(surprise_gift_logs));
          // console.log("surprise_gift_itemsToAdd:: ", missingItems);
        }
        
        fetch('/cart/add.js?Re-Added_surprise_gift_items', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: missingItems })
        })
        .then(res => res.json())
        .then(data => {
          console.log("Re-added Surprise gift items:", data);
          if (data.description) {
            const errorLog = `Error re-adding Surprise Gift | ${new Date().toLocaleString()} | Status: ${data.status} | Description: ${data.description}`;
            surprise_gift_logs.push(errorLog);
            localStorage.setItem('surprise_gift_logs', JSON.stringify(surprise_gift_logs));
          } else {
            let ids = missingItems.map(item => item.id).join(", ");
            let addedGiftLog = `Re-added Surprise Gift Items | ${new Date().toLocaleString()} | Item IDs: ${ids}`;
            surprise_gift_logs.push(addedGiftLog);
            localStorage.setItem('surprise_gift_logs', JSON.stringify(surprise_gift_logs));
          }
    
          let noteText = surprise_gift_logs.map((log, index) => `${index + 1}) ${log}`).join(" | ");
          let payload = { note: noteText };
          if (Object.keys(updates).length > 0) {
            payload.updates = updates;
          }
    
          return fetch('/cart/update.js?Added_cart_note', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(payload)
          });
        })
        .then(res => res.json())
        .then(data => {
          console.log("Cart note and updates applied:", data);
          location.replace("/checkout");
        })
        .catch(err => {
          console.error("Error during cart update with note and gifts:", err);
        }).finally(() => {
           location.replace("/checkout");
        });
      } else {
        // If everything is fine, just update note and go to checkout
        let noteText = surprise_gift_logs.map((log, index) => `${index + 1}) ${log}`).join(" | ");
        let payload = { note: noteText };
        if (Object.keys(updates).length > 0) {
          payload.updates = updates;
        }
    
        fetch('/cart/update.js?Added_cart_note', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then(res => res.json())
        .then(data => {
          console.log("Final cart note update (no kit gift issue):", data);
          location.replace("/checkout");
        })
        .catch((err) => {
          console.error("Cart note update error:", err);
        }).finally(() => {
           location.replace("/checkout");
        });
      }
      /*if (Object.keys(updates).length > 0) {
        $.ajax({
          type: "POST",
          url: "/cart/update.js?Remove_Free_Colours_items",
          data: JSON.stringify({ updates: updates }),
          contentType: "application/json",
          dataType: "json",
          success: function (response) {
            console.log("Cart updated successfully");
            document.body.dispatchEvent(new CustomEvent("product-added-to-cart"));
            document.body.dispatchEvent(new CustomEvent("cart-should-be-updated"));
            location.replace("/checkout");
          },
          error: function (error) {
            console.error("Error updating cart:", error);
            setTimeout(() => {
              location.replace("/checkout");
            }, 1000);
          },
        });
      } else {
        location.replace("/checkout");
      }*/
    }
  });
});

/* ====================== Syicky cart bar style (A/B test)  ====================== */
function initStickyCartBar() {
  const $container = $('.sticky-cart-bar');
  const $itemsContainer = $('#stickyCartItems');
  if (!$container.length) return;

  const stickyCartBar = {
    $container,
    $itemsContainer,
    maxVisibleItems: 4,

    calculateMaxItems: function() {
      const containerWidth = this.$itemsContainer.width();
      const itemWidth = $(window).width() < 768 ? 56 : 64;
      const calculatedMax = Math.floor(containerWidth / itemWidth);
      this.maxVisibleItems = Math.max(4, calculatedMax);
    },
    updateVisibility: function() {
      const $items = this.$itemsContainer.find('.sticky-cart-bar__item:not(.sticky-cart-bar__item--overflow)');
      const totalItems = parseInt(this.$container.data('total-items')) || 0;
      const $overflowItem = this.$itemsContainer.find('.sticky-cart-bar__item--overflow');
      const canShowAll = totalItems <= this.maxVisibleItems;

      if (canShowAll) {
        $items.show();
        $overflowItem.hide();
      } else {
        const itemsToShow = this.maxVisibleItems - 1;
        let visibleCount = 0;
        let hiddenCount = 0;

        $items.each(function() {
          const $item = $(this);
          if ($item.hasClass('sticky-cart-bar__item--empty')) {
            $item.hide();
            return;
          }

          // if (visibleCount < itemsToShow) {
          //   $item.show();
          //   visibleCount++;
          // } else {
          //   $item.hide();
          //   hiddenCount++;
          // }
        });

        if ($overflowItem.length && hiddenCount > 0) {
          // $overflowItem.show();
          const $counter = $overflowItem.find('.sticky-cart-bar__overflow-count');
          if ($counter.length) {
            $counter.text('+' + hiddenCount);
          }
        } else {
          // $overflowItem.hide();
        }
      }
    },

    bindEvents: function() {
      $(window).off('resize.stickyCartBar').on('resize.stickyCartBar', () => {
        this.calculateMaxItems();
        this.updateVisibility();
        setTimeout(function () {
          updateMilestoneColors();
        }, 2500);
      });
    },
    init: function() {
      this.calculateMaxItems();
      this.updateVisibility();
      this.bindEvents();
      setTimeout(function () {
        updateMilestoneColors();
      }, 1000);
    }
  };
  stickyCartBar.init();
  setTimeout(function () {
    updateMilestoneColors();
  }, 500);
}

window.addEventListener('load', function () {
  setTimeout(updateMilestoneColors, 500);
});

$(document).on("click", ".sticky-cart-bar__item.sticky-cart-bar__item--overflow", function () {
  openCartDrawer();
});

initStickyCartBar();

function updateMilestoneColors() {
  const stickyCartBat = document.querySelector(".sticky-cart-bar__wrapper .sticky-cart-bar");
  if (!stickyCartBat) return;
  const currentAmount = parseFloat(stickyCartBat.getAttribute("data-current-amount"));
  const bar = document.querySelector(".sticky-cart-bar__progress-fill");
  const dots = document.querySelectorAll(".sticky-cart-bar__milestone-dot");
  if (!bar || dots.length === 0) return;

  const barWidth = bar.offsetWidth;
  const barLeft = bar.getBoundingClientRect().left;
  const gradient = `linear-gradient(270deg,#532d6c 19.71%,#dfc3ff 80.29%)`;

  let lastReached = null;

  dots.forEach((dot) => {
    const parent = dot.closest(".sticky-cart-bar__milestone");
    const threshold = parseFloat(parent.getAttribute("data-threshold")) || 0;
    parent.classList.remove("milestone-last-reached");

    if (currentAmount >= threshold && parent.classList.contains("sticky-cart-bar__milestone--reached")) {
      lastReached = parent;
    }
  });

  if (lastReached) {
    const threshold = parseFloat(lastReached.getAttribute("data-threshold")) || 0;
    if (currentAmount <= threshold) {
      lastReached.classList.add("milestone-last-reached");
    }
  }

  dots.forEach((dot) => {
    const parent = dot.closest(".sticky-cart-bar__milestone");
    if (!parent.classList.contains("sticky-cart-bar__milestone--reached")) {
      dot.style.background = "#f8eaf6";
      dot.style.backgroundSize = "";
      dot.style.backgroundPosition = "";
      return;
    }

    dot.style.background = gradient;
    dot.style.backgroundSize = `${barWidth}px 100%`;

    const dotLeft = dot.getBoundingClientRect().left - barLeft;
    const pos = dotLeft / barWidth;

    dot.style.backgroundPosition = `-${pos * barWidth}px 0`;
  });
}
/* ====================== END Syicky cart bar style (A/B test)  ====================== */